import { Field } from '../util/components/resource/resource-fields';

export class ApiResource<TResource> {
  @Field({ readonly: true, label: $localize`ID` })
  id!: string;
  @Field({ readonly: true, label: $localize`Created at` })
  createdAt!: Date;
  @Field({ readonly: true, label: $localize`Updated at` })
  updatedAt!: Date;
  @Field({ type: () => Date, readonly: true, label: $localize`Deleted at` })
  deletedAt!: Date | null;

  constructor(props: Partial<TResource> = {}) {
    Object.assign(this, props);
  }

  toLabel() {
    return this.id;
  }
}

export type ApiResourceWith<T> = ApiResource<any> & T;
